/**
 * RGM Landing search — the parts that are not config-driven.
 *
 * The idle-state cards are Figma copy with no destination behind them yet, so they render as
 * inert placeholders with no CTA. Kept as data so wiring them to real workflows later is a
 * data change, not a component rewrite.
 */

import { ComponentType } from 'react';

import { TrendingUpIcon } from 'assets/svg/landing/kpiIcons';
import { BarChartIcon, BarChartHollowIcon } from 'assets/svg/landing/searchIcons';
import { SaleIcon as SaleIconKpi } from 'assets/svg/landing/kpiIcons';

export type SearchPlaceholderCard = {
    id: string;
    title: string;
    description: string;
    Icon: ComponentType<{ className?: string }>;
    bgClassName: string;
};

/** Suggestion rows shown while typing, before the raw-query row is appended. */
export const MAX_SUGGESTIONS = 4;

export const SEARCH_PLACEHOLDER_CARDS: SearchPlaceholderCard[] = [
    {
        id: 'analyse_trend',
        title: 'Analyse Trend',
        description: 'How can I analyse the trend in my portfolio performance over the last quarter?',
        Icon: TrendingUpIcon,
        bgClassName: 'bg-filterV2PrimaryBg',
    },
    {
        id: 'sales_performance',
        title: 'Sales Performance',
        description: 'What is my Sales Performance',
        Icon: BarChartHollowIcon,
        bgClassName: 'bg-validationErrorBg',
    },
    {
        id: 'track_portfolio',
        title: 'Track Portfolio',
        description: 'Can you help me track my portfolio performance and identify key drivers of change?',
        Icon: BarChartIcon,
        bgClassName: 'bg-landingOrangeSoftBg',
    },
    {
        id: 'sales_drivers',
        title: 'Sales Drivers',
        description:
            'What are my Sales Drivers',
        Icon: SaleIconKpi,
        bgClassName: 'bg-landingPeacockBg',
    },
];
